import { useTranslation } from "react-i18next";
import { useCheckInStatus } from "../../hooks/useCheckInStatus";
import { CheckInDetail } from "../../models/checkInDetail";
import { Button } from "../common/button";

export function CheckInStatusTable({
  artistId,
  checkIn,
}: {
  artistId: number;
  checkIn: CheckInDetail;
}) {
  const { t } = useTranslation();
  const { checkInProgress, isLoading, refetch } = useCheckInStatus(
    artistId,
    checkIn.eventId,
    checkIn.rewardId,
  );

  return (
    <>
      {isLoading && (
        <>
          <span className={"loading loading-spinner loading-md"}></span>
        </>
      )}
      {!isLoading && (
        <>
          <div className={"flex"}>
            <div className={"badge badge-ghost mr-1 align-top flex-shrink"}>
              {t("eventdetail_checkincount_update", {
                datetime: checkInProgress?.updatedAt.format(
                  t("datetime_format"),
                ),
              })}
            </div>
            <Button
              className={"btn-primary btn-circle flex-none"}
              onClick={() => !isLoading && refetch()}
            >
              {isLoading ? (
                <span className={"loading loading-ring loading-xs"}></span>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M13.836 2.477a.75.75 0 0 1 .75.75v3.182a.75.75 0 0 1-.75.75h-3.182a.75.75 0 0 1 0-1.5h1.37l-.84-.841a4.5 4.5 0 0 0-7.08.932.75.75 0 0 1-1.3-.75 6 6 0 0 1 9.44-1.242l.842.84V3.227a.75.75 0 0 1 .75-.75Zm-.911 7.5A.75.75 0 0 1 13.199 11a6 6 0 0 1-9.44 1.241l-.84-.84v1.371a.75.75 0 0 1-1.5 0V9.591a.75.75 0 0 1 .75-.75H5.35a.75.75 0 0 1 0 1.5H3.98l.841.841a4.5 4.5 0 0 0 7.08-.932.75.75 0 0 1 1.025-.273Z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </Button>
          </div>
          <div className={"py-4"}>
            <p className={"badge badge-accent"}>
              {t("eventdetail_checkincount_regular")}
            </p>
            <ul className={"list-disc list-inside"}>
              <li>
                {t("eventdetail_checkincount_capacity")}:{" "}
                {t("eventdetail_checkincount_person", {
                  count: checkInProgress?.regular.total,
                })}
              </li>
              <li>
                {t("eventdetail_checkincount_complete")}:{" "}
                {t("eventdetail_checkincount_person", {
                  count: checkInProgress?.regular.checkedIn,
                })}
              </li>
            </ul>
            <p className={"mt-3 badge badge-secondary"}>
              {t("eventdetail_checkincount_standby")}
            </p>
            <ul className={"list-disc list-inside"}>
              <li>
                {t("eventdetail_checkincount_capacity")}:{" "}
                {t("eventdetail_checkincount_person", {
                  count: checkInProgress?.spare.total,
                })}
              </li>
              <li>
                {t("eventdetail_checkincount_complete")}:{" "}
                {t("eventdetail_checkincount_person", {
                  count: checkInProgress?.spare.checkedIn,
                })}
              </li>
            </ul>
          </div>
        </>
      )}
    </>
  );
}
